var boolFormDataChanged = false;
var boolPreventTableResize = false;
var intCurrResizeColumnId = -1;
var intDragStartPosition = 0;
var boolResizing = false;
var boolBrowseExpanded = true;
var intBrowsePreviousSize = 0;
var intLeftBound = 174;
var intRightBound = 0;
var strOldPageLink;
var intKeyUpTimeoutID;
var boolDraggingSidebar = false;

$(function() { //If you want nice error in modal just add div with this id anywhere in DOM ;)
    var modalError = $('#__modal-error');
    var modalErrorLength = modalError.length;

    if(modalErrorLength === 1) { //Remember to NOT add more than one!
        var desiredWidth = modalError.data('data-width');
        var desiredHeight = modalError.data('data-height');

        desiredWidth = (typeof desiredWidth === 'undefined') ? null : desiredWidth;
        desiredHeight = (typeof desiredHeight === 'undefined') ? null : desiredHeight;

        show_modal_centered('#__modal-error', desiredWidth, desiredHeight);

    } else if(modalErrorLength > 1) {
        console.error('Cannot magically convert #__modal-error into modal - there are ' + modalErrorLength + ' with the same id!');
    }
});

function apply_form()
{
    window.onbeforeunload=null;
    document.getElementById('save_quit').value='';
}

function save_form()
{
    window.onbeforeunload=null;
    document.getElementById('save_quit').value='yes';
}

function cancel_form(boolCloseWindow)
{
    if (boolCloseWindow)
    {
        if ( window.opener != undefined )
            window.close();
    }
}

function revert_form()
{
}


function clear_form(objForm)
{
    for(var i=0; i < objForm.length; i++)
    {
        if(objForm[i].type == 'text')
            objForm[i].value = '';
        if(objForm[i].type == 'hidden')
        {
            if(objForm[i].name != 'form_submited' &&
                objForm[i].name != 'TabSelected' &&
                objForm[i].name != 'SetSelected')
            {
                objForm[i].value = '';
            }
        }
        else if((objForm[i].type == 'select-one') && objForm[i].options.length)
        {
            objForm[i].options[0].selected = true;
        }
        else if((objForm[i].type == 'select-multiple') && objForm[i].options.length)
        {
            arrSelected = Array();
            arrSelected['all'] = true;
            reset_multiselect(objForm[i].id, arrSelected);
        }
    }
}

function delete_selected()
{
    if(confirm("Are you sure you want to delete selected records?"))
    {
        document.getElementById('multi_record_action').value = 'delete_selected';
        document.getElementById('cdbadminlist_form').submit();
    }
}

function toggle_select_all(objCheckbox)
{
    for (var i=0; i < cdbadminlist_form.elements.length; i++)
    {
        var objElement = cdbadminlist_form.elements[i];

        if(objElement.name.substring(0,6) == 'MULTI_')
        {
            document.getElementById(objElement.id).checked = objCheckbox.checked;

        }
    }
}

function disable_submit_buttons()
{
    document.getElementById('apply_button').disabled = true;
    document.getElementById('save_button').disabled = true;
}

function is_form_data_changed()
{
    return boolFormDataChanged;
}

function set_form_data_changed()
{
    boolFormDataChanged = true;
}

function is_preview_ok()
{
    if(is_form_data_changed())
    {
        return confirm("You did not save the changes.\nThe page you are about to view will not reflect unsaved changes.\nWould you like to view this page anyway?");
    }
    else return true;
}

function handle_unload()
{
    if(is_form_data_changed())
        return "You did not save the changes!";
    else return;
}

function highlight_list_row(objRow, strColor)
{
    objRow.style.backgroundColor = strColor;
}

function test_func()
{}

function getCheckedValue(radioObj)
{
    if(!radioObj)
        return "";
    var radioLength = radioObj.childNodes.length;

    if(radioLength == undefined)
        if(radioObj.checked)
            return radioObj.value;
        else
            return "";

    for(var i = 0; i < radioLength; i++)
    {
        if(radioObj[i].checked)
        {
            return radioObj[i].value;
        }
    }
    return "";
}

function setCheckedValue(radioObj, newValue)
{
    if(!radioObj)
        return;

    var radioLength = radioObj.length;

    if(radioLength == undefined)
    {
        radioObj.checked = (radioObj.value == newValue.toString());
        return;
    }
    for(var i = 0; i < radioLength; i++)
    {
        radioObj[i].checked = false;
        if(radioObj[i].value == newValue.toString())
        {
            radioObj[i].checked = true;
        }
    }
}


function expand_collapse_browse(intColumnId)
{
    var elTarget = document.getElementById('column_' + intColumnId),
        elSlider = document.getElementById('slider'),
        elButton = document.getElementById('browse_expand_collapse_button');

    if (elTarget.getAttribute('data-leftbound') != 'undefined') {
        intLeftBound = elTarget.getAttribute('data-leftbound');
    }

    if(boolBrowseExpanded)
    {
        intBrowsePreviousSize = elTarget.width;
        elTarget.width = 1;
        elSlider.style.left = intLeftBound;
        elButton.src='core/assets/images/adm/pluroweb-b-browse-expand.gif';
        boolBrowseExpanded = false;
    }
    else
    {
        elTarget.width = intBrowsePreviousSize;
        elSlider.style.left = parseInt(intLeftBound) + parseInt(intBrowsePreviousSize);
        elButton.src='core/assets/images/adm/pluroweb-b-browse-collapse.gif';
        boolBrowseExpanded = true;
    }

    save_search_sidebar_status(boolBrowseExpanded);
}

function start_resize(objEvent, intColumnId, intLeftBound)
{
    document.getElementById('resize_cover_layer').style.display = 'block';
    intDragStartPosition = parseInt(document.getElementById("slider").style.left);

    var elTarget = document.getElementById('column_' + intColumnId);
    if (elTarget.getAttribute('data-leftbound') != 'undefined') {
        intLeftBound = elTarget.getAttribute('data-leftbound');
    }

    boolDraggingSidebar = true;

    document.onmouseup =  sidebar_resize_mouse_up;
    document.onmousemove = do_drag;

    intCurrResizeColumnId = intColumnId;
    return false;
}

function sidebar_resize_mouse_up()
{
    boolDraggingSidebar = false;
}

function stop_resize(objEvent)
{
    if(!boolBrowseExpanded)
    {
        boolBrowseExpanded = true;
        document.getElementById("browse_expand_collapse_button").src='assets/images/gui/pluroweb-b-browse-collapse.gif';
    }

    intRightBound = document.body.clientWidth - 200;

    if (!intDragStartPosition) {
        intDragStartPosition = intDragEndPosition;
    }

    var intColumnWidth = parseInt(document.getElementById("column_"+intCurrResizeColumnId).width);

    intDragEndPosition = parseInt(document.getElementById("slider").style.left);
    intNewWidth = (intDragEndPosition - (intDragStartPosition|0)) + intColumnWidth;

    if(intNewWidth >= 1)
    {
        document.getElementById("column_"+intCurrResizeColumnId).width = intNewWidth;
        intDragStartPosition = intDragEndPosition;
    }

    document.getElementById('resize_cover_layer').style.display = 'none';
    return false;
}

function do_drag(objEvent)
{
    if (!boolDraggingSidebar) {
        return;
    }

    intRightBound = document.body.clientWidth - 200;

    if (objEvent)
    { intCurrPos = objEvent.clientX; }
    else { intCurrPos = window.event.clientX; }

    if(intCurrPos < intLeftBound) intCurrPos = intLeftBound;
    if(intCurrPos > intRightBound) intCurrPos = intRightBound;

    document.getElementById("slider").style.left = intCurrPos;
    stop_resize(objEvent);
    return false;
}



var intRestWidth = null;
var intRestHeight = null;

function resize_width_table_new()
{
    if(document.getElementById('total_[[intSectionCounter]]_row'))
        intHeightOffset = document.getElementById('total_[[intSectionCounter]]_row').scrollHeight;
    else
        intHeightOffset = 0;

    if(BrowserDetect.browser == 'Firefox')
    {
        intWidthOffsetDiv = 0;
        intHeightOffsetDiv = 0;
        intWidthOffsetTable = 0;
        intHeightOffsetTable = -39;
    }
    else if(BrowserDetect.browser == 'Explorer')
    {
        intWidthOffsetDiv = 17;
        intHeightOffsetDiv = 17;
        intWidthOffsetTable = -17;
        intHeightOffsetTable = 17;
    }
    else
    {
        intWidthOffsetDiv = 0;
        intHeightOffsetDiv = 0;
        intWidthOffsetTable = -17;
        intHeightOffsetTable = 0;
    }

    intAvailableWidth = document.body.clientWidth - intRestWidth;

    if(intAvailableWidth + intWidthOffsetTable >= 0)
    {
        document.getElementById('cdbadminlist_div').style.width = intAvailableWidth;
        document.getElementById('cdbadminlist_main_table').style.width = intAvailableWidth + intWidthOffsetTable;
        document.getElementById('cdbadminlist_main_table_tbody').style.width = intAvailableWidth + intWidthOffsetTable;
        document.getElementById('cdbadminlist_main_table_thead').style.width = intAvailableWidth + intWidthOffsetTable;
    }

}


function resize_slider()
{
    if(document.getElementById('slider'))
    {
        document.getElementById('slider').style.height = document.body.clientHeight - 45;
    }
}


function resize_table()
{
    return;
    if(!boolPreventTableResize)
    {
        if(detect_browser()!='msie') document.getElementById('row_div').style.height = window.innerHeight-document.getElementById('list_header_cell').scrollHeight-20;

        objHeadTable = document.getElementById('head_table');
        objRowTable = document.getElementById('row_table');

        // check if table contains any rows
        if(objRowTable.rows[0])
        {
            // iterate through columns in the row table
            for (var i = 0; i < objRowTable.rows[0].cells.length; i++)
            {
                intWidth = objRowTable.rows[0].cells[i].offsetWidth;
                if ( intWidth != 0 )
                    objHeadTable.rows[0].cells[i].style.width = intWidth;
            }
        }
    }
    return false;
}

// Safari, in Private Browsing Mode, looks like it supports localStorage but all calls to setItem
// throw QuotaExceededError. We're going to detect this and just silently drop any calls to setItem
// to avoid the entire page breaking, without having to do a check at each usage of Storage.
//
// Source: https://gist.github.com/philfreo/68ea3cd980d72383c951
if (typeof localStorage === 'object') {
    try { //Test for Safari Private Mode
        localStorage.setItem('localStorage', 1);
        localStorage.removeItem('localStorage');

    } catch (e) {
        Storage.prototype._setItem = Storage.prototype.setItem;
        Storage.prototype.setItem = function() {};

        var cookie = get_cookie('_localStorageNotSupportedWarningShown');
        if(typeof cookie === 'undefined' || cookie !== '1') {
            alert('Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.');
            set_cookie('_localStorageNotSupportedWarningShown', '1');
        }
    }
}

function toggle_div(strDivId)
{
    objDiv = document.getElementById(strDivId);

    if(objDiv.style.display=='block')
    {
        objDiv.style.display='none';
    }
    else
    {
        objDiv.style.display='block';
    }
}

function show_help(x, y, name, message)
{
    document.getElementById('help_message').style.left = x-210;
    document.getElementById('help_message').style.top = y-10;
    document.getElementById('help_message').innerHTML = '<table width="100%"  border="0" cellpadding="3" cellspacing="0" bgcolor="#FFFFFF" style="border:1px solid #134596; font-size: 11px;">  <tr><td bgcolor="#134596" style="color:#FFFFFF"><b>'+name+'</b></td></tr><tr><td>'+message+'</td></tr></table>';
    document.getElementById('help_message').style.visibility = 'visible';
}

function hide_help()
{
    document.getElementById('help_message').style.visibility = 'hidden';
}

function show_row_quick_preview(intRowCounter)
{
    objQuickPreview = document.getElementById('row_quick_preview_' + intRowCounter);
    if ( objQuickPreview != undefined )
    {
        objQuickPreview.style.left = xMousePos+20;
        objQuickPreview.style.top  = yMousePos-90;
        objQuickPreview.style.display = 'block';
    }
}

function hide_row_quick_preview(intRowCounter)
{
    objQuickPreview = document.getElementById('row_quick_preview_' + intRowCounter);
    if ( objQuickPreview != undefined )
        objQuickPreview.style.display = 'none';
}

var strOldPageLink = null;
function auto_generate_page_handle()
{
    if(document.getElementById('autolink').checked)
    {
        strOldPageLink = document.getElementById('new_page_handle').value;
        generate_page_handle();
    }
    else
    {
        if ( strOldPageLink == undefined )
            strOldPageLink = '';
        document.getElementById('new_page_handle').value = strOldPageLink;
    }
}

function generate_page_handle()
{
    set_form_data_changed();
    //if ( document.getElementById('new_page_handle').value )
    //{
    //    if (confirm("Change current page link?"))
    //    {
    //date = new Date();
    strPageName = document.getElementById('page_title').value.toLowerCase();
    strPageName = strPageName.replace(/[\s,\,,\.]/g, '-');
    strPageName = strPageName.replace(/[\&]/g, '-and-');

    strPageName = strPageName.replace(/[^a-z0-9\-]*/gi, '');
    strPageName = strPageName.replace(/\-+/g,'-');

    if(strPageName.slice(-1) == '-')
        strPageName = strPageName.slice(0,-1);

    document.getElementById('new_page_handle').value = strPageName;// + '-' + date.getYear() +  zero_fill(date.getMonth(), 2) +  zero_fill(date.getDay(),2) + zero_fill(date.getHours(), 2) + zero_fill(date.getMinutes(), 2) + zero_fill(date.getSeconds(), 2);

    process_input_blur(document.getElementById('new_page_handle'));
//            alert(strPageName);
    document.getElementById('link_current_page_handle').value = document.getElementById('new_page_handle').value;
//            alert(document.getElementById('link_current_page_handle').value);
    document.getElementById('link_current_page_handle_human').value = document.getElementById('page_title').value;

    document.getElementById('link_body').value = document.getElementById('page_title').value;
    document.getElementById('link_body_on').value = document.getElementById('page_title').value;

    //    }
    //}
}

function generate_product_detail_page_handle()
{
    if ( document.getElementById('prod_page').value == '' )
    {
        date = new Date();

        str = document.getElementById('prod_sname').value.toLowerCase();
        str = str.replace(' ', '-');
        str = str.replace(/[^a-z0-9\-]*/gi, '');
        document.getElementById('prod_page').value = str + '-' + date.getYear() +  zero_fill(date.getMonth(), 2) +  zero_fill(date.getDay(),2) + zero_fill(date.getHours(), 2) + zero_fill(date.getMinutes(), 2) + zero_fill(date.getSeconds(), 2);
    }
}

function generate_product_detail_title()
{
    if ( document.getElementById('page_metatag_title').value == '' )
        document.getElementById('page_metatag_title').value = document.getElementById('prod_sname').value;
}

function generate_product_detail_page_handle_addscreen()
{
    date = new Date();

    str = document.getElementById('prod_sname').value.toLowerCase();
    str = str.replace(' ', '-');
    str = str.replace(/[^a-z0-9\-]*/gi, '');
    document.getElementById('prod_page').value = str + '-' + date.getYear() +  zero_fill(date.getMonth(), 2) +  zero_fill(date.getDay(),2) + zero_fill(date.getHours(), 2) + zero_fill(date.getMinutes(), 2) + zero_fill(date.getSeconds(), 2);
}

function generate_product_detail_title_addscreen()
{
    document.getElementById('page_metatag_title').value = document.getElementById('prod_sname').value;
}
function zero_fill(str, len)
{
    str = str.toString();
    var ret = '';
    if ( str.length < len )
    {
        for ( var i=0; i< len-str.length; i++ )
            ret = ret + '0';

        ret = ret + str;
    }

    if ( ret == '' )
        ret = str;

    return ret;
}

function clear_field_value(strFieldId)
{
    if (!strFieldId) {
        return;
    }

    const field = document.getElementById(strFieldId);
    if (!field) {
        return;
    }

    field.value = '';
    field.dispatchEvent(new Event('change'));
}

function generate_link_name()
{
    if ( get_checked_radio_value(document.forms[0].link_to_type) == 'page_handle' )
        strValue = document.getElementById('link_to_page_handle_human').value;
    else
        strValue = document.getElementById('link_url').value;

    document.getElementById('link_name').value = strValue;
    document.getElementById('link_body').value = strValue;
    document.getElementById('link_body_on').value = strValue;
}

function generate_link_name_from_page_title()
{
    strValue = document.getElementById('page_title').value;

    document.getElementById('link_name').value = strValue;
    document.getElementById('link_body').value = strValue;
    document.getElementById('link_body_on').value = strValue;
}

function prefil_menu_link_body()
{
    if ( document.getElementById('link_body').value == '' )
    {
        document.getElementById('link_body').value        = document.getElementById('link_name').value;
        document.getElementById('link_body_on').value    = document.getElementById('link_name').value;
    }
}

function generate_page_title()
{
    if ( document.getElementById('page_title').value == '' )
    {
        document.getElementById('page_name').value = document.getElementById('page_title').value;
    }
}

function preview_page_url(url, linkpre, linkpost)
{
    if ( document.getElementById('page_handle').value != '' )
        document.getElementById('page_link').innerHTML = url + linkpre + document.getElementById('page_handle').value + linkpost;
}

if (document.layers) { // Netscape
    document.captureEvents(Event.MOUSEMOVE);
    document.onmousemove = captureMousePosition;
} else if (document.all) { // Internet Explorer
    document.onmousemove = captureMousePosition;
} else if (document.getElementById) { // Netcsape 6
    document.onmousemove = captureMousePosition;
}
// Global variables
xMousePos = 0; // Horizontal position of the mouse on the screen
yMousePos = 0; // Vertical position of the mouse on the screen
xMousePosMax = 0; // Width of the page
yMousePosMax = 0; // Height of the page

function captureMousePosition(e) {
    if (document.layers) {
        // When the page scrolls in Netscape, the event's mouse position
        // reflects the absolute position on the screen. innerHight/Width
        // is the position from the top/left of the screen that the user is
        // looking at. pageX/YOffset is the amount that the user has
        // scrolled into the page. So the values will be in relation to
        // each other as the total offsets into the page, no matter if
        // the user has scrolled or not.
        xMousePos = e.pageX;
        yMousePos = e.pageY;
        xMousePosMax = window.innerWidth+window.pageXOffset;
        yMousePosMax = window.innerHeight+window.pageYOffset;
    } else if (document.all) {
        // When the page scrolls in IE, the event's mouse position
        // reflects the position from the top/left of the screen the
        // user is looking at. scrollLeft/Top is the amount the user
        // has scrolled into the page. clientWidth/Height is the height/
        // width of the current page the user is looking at. So, to be
        // consistent with Netscape (above), add the scroll offsets to
        // both so we end up with an absolute value on the page, no
        // matter if the user has scrolled or not.

        //if(typeof(window.document.body)!="undefined" && typeof(document)!="undefined")
        //{
        //    xMousePos = window.event.x+document.body.scrollLeft;
        //    yMousePos = window.event.y+document.body.scrollTop;
        //    xMousePosMax = document.body.clientWidth+document.body.scrollLeft;
        //    yMousePosMax = document.body.clientHeight+document.body.scrollTop;
        //}
    } else if (document.getElementById) {
        // Netscape 6 behaves the same as Netscape 4 in this regard
        xMousePos = e.pageX;
        yMousePos = e.pageY;
        xMousePosMax = window.innerWidth+window.pageXOffset;
        yMousePosMax = window.innerHeight+window.pageYOffset;
    }
}

/**
 * New money format uses numeral.js
 * http://numeraljs.com/
 *
 * @param {String} input
 *
 * @return {String}
 */
function floatToMoneyFormat(input)
{
    return numeral(input).format('0,0.00');
}

function float_to_money(input, boolIgnoreCents, intPrecision)
{
    if ( intPrecision == undefined )
        intPrecision = 2;

    input = input.toString();
    input = input.replace(/[^0-9\.]*/gi, '');

    if ( input )
    {
        money = input.split('.');
        if ( money[0].length == 0 )
            dolars = '0';
        else
            dolars = money[0];

        if ( boolIgnoreCents )
            return dolars;

        if (money.length > 1)
            cents = money[1];
        else
        {
            if ( intPrecision == 4 )
                cents = '0000';
            else
                cents = '00';
        }

        if ( intPrecision == 4 )
        {
            switch ( cents.length )
            {
                case 0:
                    cents = '0000';
                    break;
                case 1:
                    cents = cents + '000';
                    break;
                case 2:
                    cents = cents + '00';
                    break;
                case 3:
                    cents = cents + '0';
                    break;
            }

            if ( cents.length > 4)
                cents = cents.substr(0, 4);
        }
        else
        {
            if (cents.length == 0)
                cents = '00';
            if (cents.length == 1)
                cents = cents + '0';
            if ( cents.length > 2)
                cents = cents.substr(0, 2);
        }

        return dolars + '.' + cents;
        return dolars + '.' + cents;
    }
    else
        return '';
}

function loadingScreen()
{
    objInputFields = document.getElementsByTagName('SELECT');
    for ( i=0; i<objInputFields.length; i++)
        objInputFields[i].disabled = true;

    objBody = document.body;
    objLayer = document.createElement("DIV");

    objLayer.style.position     = "absolute";
    objLayer.style.visibility     = "visible";
    objLayer.style.left            = "0px";
    objLayer.style.top            = "0px";
    objLayer.style.height        = "100%";

    objLayer.innerHTML = '<div style="z-index:1; filter:alpha(opacity=80); -moz-opacity:0.8; opacity:0.8; background-color:#FFFFFF; width:100%; height:100%"><div style="z-index:2; height:100%; filter:alpha(opacity=100); -moz-opacity:1.0; opacity:1.0; position:relative"><table width="100%" height="100%" border="0" cellspacing="0" cellpadding="0"><tr><td valign="middle"><table width="300" align="center" border="0" cellspacing="0" cellpadding="20" style="border:3px solid #00084A" bgcolor="#CEE5FF"><tr><td align="center"><font color="#00084A" size="4" face="Arial, Helvetica, sans-serif"><b>Please wait. Loading... </b></font></td></tr></table></td></tr></table></div></div>';

    objBody.appendChild(objLayer);
}

var row_selection = Array();
function highlight(obj, table_id, id, action, original_color, new_color)
{
    if ( row_selection[table_id] == undefined )
        row_selection[table_id] = Array();

    if (action == 'click')
    {
        if (row_selection[table_id][id] == undefined)
        {
            obj.style.backgroundColor = new_color;
            row_selection[table_id][id] = 1;
            if ( document.getElementById(id) != undefined )
                document.getElementById(id).checked = true;
        } else {
            obj.style.backgroundColor = original_color;
            row_selection[table_id][id] = undefined;
            if ( document.getElementById(id) != undefined )
                document.getElementById(id).checked = false;
        }
    }

    if (action == 'over')
    {
        if (row_selection[table_id][id] == undefined)
            obj.style.backgroundColor = new_color;
    }

    if (action == 'out')
    {
        if (row_selection[table_id][id] == undefined)
            obj.style.backgroundColor = original_color;
    }
}

function update_field_on_advanced_tab(objSource, strFieldType)
{
    // regular mapping
    strTargetId = objSource.id;
    strTargetId = strTargetId.replace('_simple', '');
    objTarget = document.getElementById(strTargetId);
    objTarget.value = objSource.value;
    process_input_blur(objTarget);

    // additional mapping per field
    switch(strFieldType)
    {
        case 'directory_type_name':
            document.getElementById('prod_sname').value = objSource.value;
            process_input_blur(document.getElementById('prod_sname'));
            generate_product_detail_page_handle();
            process_input_blur(document.getElementById('prod_page'));
            break;
    }
}

function update_field_on_simple_tab(objSource, strFieldType)
{
    // regular mapping
    strTargetId = objSource.id + '_simple';
    objTarget = document.getElementById(strTargetId);
    objTarget.value = objSource.value;
    process_input_blur(objTarget);

    // additional mapping per field
    switch(strFieldType)
    {
    }
}

function display_sort_order_disabled_message()
{
    alert('Please sort by Order column to enable this feature.');
    return false;
}

function tab_disabled_upon_add(strMessage)
{
    if ( strMessage != undefined )
        alert(strMessage);
    else
        alert('This tab is disabled upon adding process. Please save to continue');

    return false;
}




var BrowserDetect = {
    init: function () {
        this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
        this.version = this.searchVersion(navigator.userAgent)
            || this.searchVersion(navigator.appVersion)
            || "an unknown version";
        this.OS = this.searchString(this.dataOS) || "an unknown OS";
    },
    searchString: function (data) {
        for (var i=0;i<data.length;i++)    {
            var dataString = data[i].string;
            var dataProp = data[i].prop;
            this.versionSearchString = data[i].versionSearch || data[i].identity;
            if (dataString) {
                if (dataString.indexOf(data[i].subString) != -1)
                    return data[i].identity;
            }
            else if (dataProp)
                return data[i].identity;
        }
    },
    searchVersion: function (dataString) {
        var index = dataString.indexOf(this.versionSearchString);
        if (index == -1) return;
        return parseFloat(dataString.substring(index+this.versionSearchString.length+1));
    },
    dataBrowser: [
        {
            string: navigator.userAgent,
            subString: "Edge",
            identity: "Edge"
        },
        {
            string: navigator.userAgent,
            subString: "Chrome",
            identity: "Chrome"
        },
        {     string: navigator.userAgent,
            subString: "OmniWeb",
            versionSearch: "OmniWeb/",
            identity: "OmniWeb"
        },
        {
            string: navigator.vendor,
            subString: "Apple",
            identity: "Safari",
            versionSearch: "Version"
        },
        {
            prop: window.opera,
            identity: "Opera"
        },
        {
            string: navigator.vendor,
            subString: "iCab",
            identity: "iCab"
        },
        {
            string: navigator.vendor,
            subString: "KDE",
            identity: "Konqueror"
        },
        {
            string: navigator.userAgent,
            subString: "Firefox",
            identity: "Firefox"
        },
        {
            string: navigator.vendor,
            subString: "Camino",
            identity: "Camino"
        },
        {        // for newer Netscapes (6+)
            string: navigator.userAgent,
            subString: "Netscape",
            identity: "Netscape"
        },
        {
            string: navigator.userAgent,
            subString: "MSIE",
            identity: "Explorer",
            versionSearch: "MSIE"
        },
        {
            string: navigator.userAgent,
            subString: "Gecko",
            identity: "Mozilla",
            versionSearch: "rv"
        },
        {         // for older Netscapes (4-)
            string: navigator.userAgent,
            subString: "Mozilla",
            identity: "Netscape",
            versionSearch: "Mozilla"
        }
    ],
    dataOS : [
        {
            string: navigator.platform,
            subString: "Win",
            identity: "Windows"
        },
        {
            string: navigator.platform,
            subString: "Mac",
            identity: "Mac"
        },
        {
            string: navigator.userAgent,
            subString: "iPhone",
            identity: "iPhone/iPod"
        },
        {
            string: navigator.platform,
            subString: "Linux",
            identity: "Linux"
        }
    ]

};

BrowserDetect.init();

function print_report()
{
    resize_to_print();
    window.print();
    resize_table_new();
    return false;
}

function resize_to_print()
{
    document.getElementById('cdbadminlist_div').style.width = '';
    document.getElementById('cdbadminlist_div').style.height = 'auto';

    document.getElementById('cdbadminlist_main_table').style.width = '';
    document.getElementById('cdbadminlist_main_table_tbody').style.width = '';
    document.getElementById('cdbadminlist_main_table_thead').style.width = '';
}

function resize_table_new()
{
    if(document.getElementById('total_[[intSectionCounter]]_row'))
        intHeightOffset = document.getElementById('total_[[intSectionCounter]]_row').scrollHeight;
    else
        intHeightOffset = 0;

    if(BrowserDetect.browser == 'Firefox')
    {
        intWidthOffsetDiv = 0;
        intHeightOffsetDiv = 0;
        intWidthOffsetTable = 0;
        intHeightOffsetTable = -39;
    }
    else if(BrowserDetect.browser == 'Explorer')
    {
        intWidthOffsetDiv = 17;
        intHeightOffsetDiv = 17;
        intWidthOffsetTable = -17;
        intHeightOffsetTable = 17;
    }
    else
    {
        intWidthOffsetDiv = 0;
        intHeightOffsetDiv = 0;
        intWidthOffsetTable = -17;
        intHeightOffsetTable = 0;
    }

    // adjust width
    if(intRestWidth === null)
    {
//        if(document.getElementById('cdbadminlist_div').clientWidth)
//            intOriginalDivWidth = document.getElementById('cdbadminlist_div').clientWidth;
//        else
//            intOriginalDivWidth = document.getElementById('cdbadminlist_div').scrollWidth;

        if(document.getElementById('cdbadminlist_container_td').offsetWidth > document.getElementById('cdbadminlist_div').scrollWidth)
            intOriginalDivWidth = document.getElementById('cdbadminlist_container_td').offsetWidth;
        else
            intOriginalDivWidth = document.getElementById('cdbadminlist_div').scrollWidth;


        intRestWidth = document.body.scrollWidth - intOriginalDivWidth;
    }

    intAvailableWidth = document.body.clientWidth - intRestWidth;

    if(intAvailableWidth + intWidthOffsetTable >= 0)
    {
        document.getElementById('cdbadminlist_div').style.width = intAvailableWidth;
        document.getElementById('cdbadminlist_main_table').style.width = intAvailableWidth + intWidthOffsetTable;
        document.getElementById('cdbadminlist_main_table_tbody').style.width = intAvailableWidth + intWidthOffsetTable;
        document.getElementById('cdbadminlist_main_table_thead').style.width = intAvailableWidth + intWidthOffsetTable;
    }

    // adjust height
    if(intRestHeight === null || (BrowserDetect.browser !== 'Explorer' && BrowserDetect.browser !== 'Edge'))
    {
        if(document.getElementById('cdbadminlist_container_td').offsetHeight > document.getElementById('cdbadminlist_div').scrollHeight)
            intOriginalDivHeight = document.getElementById('cdbadminlist_container_td').offsetHeight;
        else
            intOriginalDivHeight = document.getElementById('cdbadminlist_div').scrollHeight;

        intRestHeight = document.body.scrollHeight - intOriginalDivHeight;
    }

    intAvailableHeight = document.body.clientHeight - intRestHeight;

    if(intAvailableHeight > 100)
    {
        document.getElementById('cdbadminlist_div').style.height = intAvailableHeight;
    }
    else
    {
        document.getElementById('cdbadminlist_div').style.height = 400;
    }

    if(document.getElementById('cdbadminlist_main_table_tbody').scrollHeight > intAvailableHeight)
    {
        if(BrowserDetect.browser !== 'Explorer' && BrowserDetect.browser !== 'Edge')
        {
            document.getElementById('cdbadminlist_main_table').style.height =        intAvailableHeight + intHeightOffsetTable;
            document.getElementById('cdbadminlist_main_table_tbody').style.height = intAvailableHeight + intHeightOffsetTable;
        }
    }
    else
    {
        document.getElementById('cdbadminlist_main_table').style.height            =  '';
        document.getElementById('cdbadminlist_main_table_tbody').style.height    =  '';
    }
}

function copy_to_field(objFrom, strIdTo)
{
    document.getElementById(strIdTo).value = objFrom.value;
}

function set_degrees(strDegreesSelectPrefix, strDegreesId)
{
    var strDegrees = '';

    for(i=1; i<=6; i++)
    {

        if(document.getElementById(strDegreesSelectPrefix + i).value)
        {
            if(strDegrees != '')
            {
                strDegrees = strDegrees + ', ';
            }

            strDegrees = strDegrees + document.getElementById(strDegreesSelectPrefix + i).value;
        }
    }

    document.getElementById(strDegreesId).value = strDegrees;
    $("#"+strDegreesId).trigger('change');
}

(function() {
    'use strict';

    /**
     * @param {string|null} company
     * @param {string|null} companyDba
     * @return {string|null}
     */
    const getCompanyPart = function(company, companyDba) {
        if (company === null && companyDba === null) {
            return null;
        }

        if (company === null) {
            return companyDba;
        }

        if (companyDba === null) {
            return company;
        }

        return `${companyDba} / ${company}`;
    };

    /**
     * @return {void}
     */
    window.populate_account_name = function() {
        if (window.boolAccountNameChangedByUser) {
            return;
        }

        const firstName = (document.getElementById('user_fname') && document.getElementById('user_fname').value) || null;
        const lastName = (document.getElementById('user_lname') && document.getElementById('user_lname').value) || null;
        const middleName = (document.getElementById('user_mname') && document.getElementById('user_mname').value) || null;
        const company = (document.getElementById('user_company') && document.getElementById('user_company').value) || null;
        const companyDba = (document.getElementById('user_company_dba') && document.getElementById('user_company_dba').value) || null;
        const degrees = (
            document.getElementById('user_degrees') &&
            Array.from(document.getElementById('user_degrees').options)
                .map(item => item.value)
                .join(', ')
        ) || null;
        const email = (document.getElementById('user_email') && document.getElementById('user_email').value) || null;

        let userName = firstName || '';
        userName += middleName === null ? '' : ` ${middleName.substr(0, 1)}.`;
        userName += lastName === null ? '' : ` ${lastName}`;
        userName = userName.trim();

        const companyPart = getCompanyPart(company, companyDba);
        if (companyPart !== null) {
            userName = companyPart + (userName ? ` - ${userName}` : '');
        }
        if (degrees !== null) {
            userName += userName ? `, ${degrees}` : degrees;
        }
        userName = userName.trim();

        userName = userName || email || 'Temp';
        document.getElementById('user_name').value = userName;
    };
})();


function update_field_match_mode(objModeField)
{
    strId = objModeField.id.replace('matchmode__','');
    objInputField = document.getElementById(strId);

    if(typeof(objInputField.originalValue) === 'undefined')
    {
        objInputField.originalValue = '';
    }

    if(objInputField.value != '<null>' && objInputField.value != '<nonnull>')
        objInputField.originalValue = objInputField.value;

    if(objModeField.value == 'null')
    {
        objInputField.value = '<null>';
        objInputField.readOnly = true;
    }
    else if(objModeField.value == 'nonnull')
    {
        objInputField.value = '<nonnull>';
        objInputField.readOnly = true;
    }
    else
    {
        objInputField.value = objInputField.originalValue;
        objInputField.readOnly = false;
    }
}

function set_null_text_fields_readonly()
{
    return;
    objForm = document.getElementById('dba_list_search_reports_crm_contacts');

    for(var i=0; i < objForm.length; i++)
    {
        if(objForm[i].type == 'text')
        {
            if(objForm[i].value == '<null>' || objForm[i].value == '<nonnull>')
            {
                objForm[i].readOnly = true;
            }
        }
    }
}

function update_multiselect(objField)
{
    strId = objField.id.replace('[]','');
    objModeField =     document.getElementById('matchmode__' + strId);

    if(objField.value == '<all>')
        objModeField.value = 'all';
    else if(objField.value == '<null>')
        objModeField.value = 'null';
    else if(objField.value == '<nonnull>')
        objModeField.value = 'nonnull';
}

function update_multiselect_match_mode(objModeField)
{
    strId = objModeField.id.replace('matchmode__','');
    objInputField = document.getElementById('select_filter__' + strId);

    if(objModeField.value != 'null' && objModeField.value != 'nonnull' && objModeField.value != 'all')
    {
        //if(objModeField.value == 'listvalues')
        {
            var objOption = new Option('... Loading ... Please wait.', '', true);

            objMultiSelect = document.getElementById(strId+'[]');
            objMultiSelect.innerHTML = '';
            objMultiSelect.options.length = 0;
            objMultiSelect.add(objOption);
        }

        process_key_press(objInputField);

        if(objModeField.value.substring(1, 13) == 'filter_list__')
            objInputField.disabled = true;
        else
            objInputField.disabled = false;
    }
    else
    {
        arrSelected = Array();
        arrSelected[objModeField.value] = true;
        reset_multiselect(strId+'[]', arrSelected);
        objInputField.disabled = true;
    }
}

function start_detect_keys(objField)
{
    objField.onkeydown = function(event)
    {
        this.oldValue = this.value
    };

    objField.onkeyup = function(event)
    {
        clearTimeout(intKeyUpTimeoutID);

        if(this.oldValue != this.value)
        {
            objParam = this;

            if(this.value.length < 2)
            {
                intKeyUpTimeoutID = setTimeout(function(){process_key_press(objParam);}, 150);
            }
            else
            {
                process_key_press(objParam);
            }
        }
    };
}


function process_key_press(objField)
{
    var strId = objField.id.replace("select_filter__", "");
    var strMatchMode = document.getElementById('matchmode__'+strId).value;

    if(    objField.value != "" || strMatchMode.substring(0, 13) == 'filter_list__')
    {
        strParams = 'multi_select_filter=' + encodeURIComponent(objField.value) + '&multi_select_filter_match_mode=' + encodeURIComponent(strMatchMode) + '&multi_select_column=' + encodeURIComponent(strId);

        send_ajax_request('populate_dropdown_ajax', '?ph=ajax_get_multi_select', 'POST', strParams, true);
    }
    else
    {
        reset_multiselect(strId+'[]', Array());
    }
}


function reset_multiselect(strId, arrSelected)
{
    var objSelect = document.getElementById(strId);
    var strOptionsHTML = '';
//    objSelect.options.length=0;
    var boolIsIE = is_ie();

    if(
        strId != 'user_degrees[]' &&
        strId != 'user_sex[]' &&
        strId != 'user_deceased[]' &&
        strId != 'user_custom_type_id__board_type_all[]' &&
        strId != 'user_custom_type_id__board_status_all[]'      &&
        strId != 'store_handle[]' &&
        strId != 'paygate_handle[]' &&

        strId != 'user_board_abaarm_diplomate[]' &&
        strId != 'user_board_abaarm_certified[]' &&
        strId != 'user_board_abaahp_diplomate[]'
    )
    {

        if(boolIsIE)
        {
            objSelectDIV = document.getElementById('div_multi_select__' + strId);

            strOptionsHTML = '<select name="' + strId + '" id="' + strId + '" tabindex="0" class="field_normal" style="width:' + objSelect.style.width + '; height:' + objSelect.style.height + '" size="8" multiple onchange="update_multiselect(this)">' + strOptionsHTML;
            strOptionsHTML += '<option value="<all>" title="-- All --"  selected="selected">-- All --</option>';
            strOptionsHTML += '<option value="<null>" title="-- Only Empty --"  selected="selected">-- Only Empty --</option>';
            strOptionsHTML += '<option value="<nonnull>" title="-- Only Non-Empty --"  selected="selected">-- Only Non-Empty --</option>';
            strOptionsHTML += '</select>';

            objSelectDIV.innerHTML = strOptionsHTML;
        }
        else
        {
            objSelect.innerHTML = '';
            objSelect.options.length=0;
            objSelect.add(new Option('-- All --', '<all>'));
            objSelect.add(new Option('-- Only Empty --', '<null>'));
            objSelect.add(new Option('-- Only Non-Empty --', '<nonnull>'));
        }
    }
    else
    {
        for(i=0; i<objSelect.options.length; i++)
        {
            objSelect.options[i].selected = false;
        }
    }

    if(!boolIsIE)
    {
        if(
            //strId != 'user_request_from_utm_source[]' &&
            strId != 'user_request_from_utm_medium[]' &&
            strId != 'user_request_from_utm_campaign[]' &&
            strId != 'user_request_from_page_handle[]' &&
            strId != 'user_request_from_form_handle[]' &&
            strId != 'user_request_from_lead_source[]' &&
            strId != 'user_interest_handle[]'
        )
        {
            objSelect.options[0].selected = arrSelected['all'];
            objSelect.options[1].selected = arrSelected['null'];
            objSelect.options[2].selected = arrSelected['nonnull'];
        }
    }
}

function populate_dropdown_ajax(objXML)
{
    var strColumn = "";
    var boolIsIE = is_ie();
    var arrNodes = objXML.documentElement.childNodes;


    if(boolIsIE)
    {
        var strOptionsHTML = "";

        for(var i=0; i<arrNodes.length; i++)
        {
            if(arrNodes[i].tagName == 'multi_select_column')
            {
                strColumn = arrNodes[i].text;
                break;
            }
        }

        objSelectDIV = document.getElementById('div_multi_select__' + strColumn + '[]');

        for(var i=0; i<arrNodes.length; i++)
        {
            if(arrNodes[i].tagName == 'multi_select_option')
            {
                strOptionValue = decodeURIComponent(arrNodes[i].getAttribute('value').replace(/&37;/g,'%')).replace(/\"/g,'&quot;').replace(/&nbsp;/g,' ');

                strOptionText  = decodeURIComponent(arrNodes[i].text).replace(/\"/g,'&quot;').replace(/&37;/g,'%');

                strOptionsHTML += '<option value="' + strOptionValue + '" title="' + strOptionText + '"  selected="selected">' + strOptionText + '</option>';
            }
        }


        objSelect = document.getElementById(strColumn + '[]');

        strOptionsHTML = '<select name="' + strColumn + '[]" id="' + strColumn + '[]" tabindex="0" class="field_normal" style="width:' + objSelect.style.width + '; height:' + objSelect.style.height + '" size="8" multiple onchange="update_multiselect(this)">' + strOptionsHTML;
        strOptionsHTML += '</select>';

        //alert("OK2");
        //objSelect.options.length=0;
        objSelectDIV.innerHTML = strOptionsHTML;
    }
    else
    {
        var objOption = new Option("","");

        for(var i=0; i<arrNodes.length; i++)
        {
            if(arrNodes[i].tagName == 'multi_select_column')
            {
                strColumn = arrNodes[i].textContent;
                var objSelect = document.getElementById(strColumn + '[]');
                objSelect.options.length = 0;
            }
            else if(arrNodes[i].tagName == 'multi_select_option')
            {
                if(arrNodes[i].getAttribute('value') != null)
                {
                    strOptionValue    = htmlentities_to_latin(arrNodes[i].getAttribute('value').replace(/&nbsp;/g,' '));
                }
                else
                {
                    strOptionValue = "";
                }

                if(arrNodes[i].textContent != null)
                {
                    strOptionText    = htmlentities_to_latin(arrNodes[i].textContent.replace(/&nbsp;/g,' '));
                }
                else
                {
                    strOptionText = "";
                }


                (objOption = new Option(strOptionText, strOptionValue, true)).setAttribute("title", strOptionText);
                objSelect.add(objOption);
            }
        }
    }
}

function set_zip_distance_field_enabled_onload()
{
    objMatchMode = document.getElementById('matchmode__user_zip');

    if(objMatchMode.options[objMatchMode.selectedIndex].value == 'filter_list__distance')
    {
        document.getElementById('user_zip_distance').disabled = false;
        if(document.getElementById('user_zip_distance').value == 'Select Distance Match')
            document.getElementById('user_zip_distance').value = '';
    }
    else
    {
        document.getElementById('user_zip_distance').disabled = true;
        document.getElementById('user_zip_distance').value = 'Select Distance Match';
    }


    objMatchMode = document.getElementById('matchmode__user_sa_zip');

    if(objMatchMode.options[objMatchMode.selectedIndex].value == 'filter_list__distance')
    {
        document.getElementById('user_sa_zip_distance').disabled = false;
        if(document.getElementById('user_sa_zip_distance').value == 'Select Distance Match')
            document.getElementById('user_sa_zip_distance').value = '';
    }
    else
    {
        document.getElementById('user_sa_zip_distance').disabled = true;
        document.getElementById('user_sa_zip_distance').value = 'Select Distance Match';
    }
}

function set_dispcol_checkboxes(strCheckboxId, boolChecked)
{
    strTableId = 'table_dispcols__' + strCheckboxId.replace('dispcol_multicheck__','');
    $('#'+strTableId).find('input').each(function() {this.checked = boolChecked;});
}

function export_report(strUrl){
    var strType = $(".export_option_select").val();
    if(typeof(strType) != 'undefined' && strType == 'system' )
    {
        if(strUrl.indexOf("franky") > -1)
            strUrl = strUrl+'?export_type=system';
        else
            strUrl = strUrl+'&export_type=system';
    }
    document.location = strUrl;
    return false;
}

function subscribe_report(strUrl)
{
    var strHandle = $(".newsletter_group_handle").val();

    if(typeof(strHandle) == 'undefined' || ( typeof(strHandle) != 'undefined' && strHandle == '') )
    {
        alert('Please select a newsletter from the drop down list.');
        return false;
    }

    if($(".dropdown_newsletter_group_handle :selected").val() == '__other')
        strGroup = strHandle;
    else
        strGroup = $(".dropdown_newsletter_group_handle :selected").text();

    var confirmMessage = "Are you sure you want to subscribe all e-mails from this report to \"" +
        decodeURIComponent(strGroup) +
        "\"?";

    if (confirm(confirmMessage) == true) {

        var subType = $("#newsletter_export_subscription_type");
        if (subType.get(0)) {
            subType = $(subType).val();
        } else {
            subType = "subscribe";
        }

        strUrl = strUrl + '&newsletter_group_handle=' + encodeURIComponent(strHandle) +
            '&newsletter_subscribe_type=' + encodeURIComponent(subType);

        show_window_centered(strUrl,"Export",600,200);
        return false;
    }
    return false;
}

function save_search_sidebar_status(boolBrowseExpanded){

    var page = get_search_sidebar_page();
    set_cookie('sidebar_status_'+page+'_'+strUserEncoded, boolBrowseExpanded, 30);
}

function load_search_sidebar_status(){
    if($("#resize_cover_layer").length){
        var page = get_search_sidebar_page();
        var status = get_cookie('sidebar_status_'+page+'_'+strUserEncoded);
        if(status == 'false'){
            expand_collapse_browse(0);
        }
    }
}

function get_search_sidebar_page()
{
    var strRequest = window.location.search;
    if(strRequest.indexOf(',') == -1)
        var page = strRequest.substring(strRequest.indexOf('ph=')+3);
    else
        var page = strRequest.substring(strRequest.indexOf('ph=')+3,strRequest.indexOf(','));
    return page;
}

function calculate_time_length_field(){
    $(".time_length_fields_container input").keyup(function(e){
        this.value = this.value.replace(/\D/g,'');
        var objContainer = $(this).parents(".time_length_fields_container");

        var str_h = $(objContainer).find("input[name$='__h']").val();
        var str_m = $(objContainer).find("input[name*='__m']").val();
        var str_s = $(objContainer).find("input[name*='__s']").val();

        var int_time  = (str_h*60*60) + (str_m*60) + (str_s*1);
        $(objContainer).find("input.hidden_time_length").val(int_time);
    });
}

function prefil_time_length_field(strSelectorId){
    var int_time = $("#"+strSelectorId).val()*1;
    if(int_time > 0)
    {
        var int_h = Math.floor(int_time/(3600));
        var int_m = Math.floor((int_time - (int_h*3600))/60);
        var int_s = int_time - (int_h*3600) - (int_m*60);

        var objContainer = $("#"+strSelectorId).parents(".time_length_fields_container");

        if(int_h > 0)
            $(objContainer).find("input[name$='__h']").val(int_h);

        if(int_m > 0)
            $(objContainer).find("input[name$='__m']").val(int_m);

        if(int_s > 0)
            $(objContainer).find("input[name$='__s']").val(int_s);
    }
}


function calculate_task_length_field(){
    $(".task_length_fields_container select").change(function(e){

        var objContainer = $(this).parents(".task_length_fields_container");

        var str_d = $(objContainer).find("select[name*='__d']").val();
        var str_h = $(objContainer).find("select[name$='__h']").val();
        var str_m = $(objContainer).find("select[name*='__m']").val();

        var int_time  = (str_d*24*60) + (str_h*60) + (str_m*1);
        $(objContainer).find("input.hidden_task_length").val(int_time);
    });
}
function prefil_task_length_field(strSelectorId){
    var int_time = $("#"+strSelectorId).val()*1;
    if(int_time > 0)
    {
        var int_d = Math.floor(int_time/(1440));
        var int_h = Math.floor((int_time - (int_d*1440))/60);
        var int_m = int_time - (int_d*1440) - (int_h*60);

        var objContainer = $("#"+strSelectorId).parents(".task_length_fields_container");

        if(int_d > 0)
            $(objContainer).find("select[name$='__d']").val(int_d);

        if(int_h > 0)
            $(objContainer).find("select[name$='__h']").val(int_h);

        if(int_m > 0)
            $(objContainer).find("select[name$='__m']").val(int_m);
    }
}

function init_preloader(strPageHandle)
{
    var boolPreload = true;
    window.top.boolPreload = true;

    $(document).ready(function(){
        $('.no_preload').click(function(){
            boolPreload = false;
            window.top.boolPreload = false;
            $(".iframe_preloader").hide();
        });
        $('*:not(.no_preload)').mousedown(function(){
            boolPreload = true;
            window.top.boolPreload = true;
        });
    });

    $(window).bind('beforeunload', function(e) {
        if ( window.top.boolPreload != false && boolPreload != false)
            preload(strPageHandle);
    });

}

function  preload(strPageHandle)
{
    $(".iframe_preloader."+strPageHandle).css('display','block');
    $('html').css('cssText','overflow: hidden !important');
}

//JQUERY PLUGINS
(function ( $ ) {
    $.fn.open_hours = function( options ) {
        var settings = $.extend({
            "option1": "1"
        }, options );
        var selector = this.attr('id');
        var hour = this.val();

        //poulate dd
        if(hour != ''){
            var init_h = hour.substr(0,2);
            var init_m = hour.substr(2,2);

            if(init_h == '00')
                init_h = '12';

            if(init_h > 11)
                var init_ampm = 'pm';
            else
                var init_ampm = 'am';

            if(init_h > 12)
                init_h = (init_h*1) - 12;

            if((init_h*1) < 10)
                init_h = '0'+(init_h*1);
            else
                init_h = ''+init_h;

            $("#"+selector+"_time_hh").val(init_h);
            $("#"+selector+"_time_mm").val(init_m);
            $("#"+selector+"_time_ampm").val(init_ampm);

        }

        $("#"+selector+"_time_hh, #"+selector+"_time_mm, #"+selector+"_time_ampm").bind('change', function() {
            hour = recalculate_time(selector);
            if(hour == false)
                hour = '';

            $("#"+selector).val(hour);
        });
    };

    function recalculate_time(selector){
        var h = $("#"+selector+"_time_hh").val()+'';
        var m = $("#"+selector+"_time_mm").val()+'';
        var ampm = $("#"+selector+"_time_ampm").val();

        if( h != '' && m != '' && ampm != ''){
            if( ampm == 'am' && h == '12' )
                h = '00';
            else if( ampm == 'pm' &&  h !== '12' )
                h = (h*1)+12;

            var hour = h+m;
            return hour;
        } else if (h !== '' || m !== '' || ampm !== '') {
            return '----';
        } else {
            return false;
        }
    }
}( jQuery ));

//product options
function display_product_options_edit(objProdOptions){
    var objOptionTemplate = $(".js_prod_options_template");

    $.each(objProdOptions, function(intIndex, objOption){
        var objHtmlOption = objOptionTemplate.clone();
        objHtmlOption.find(".field_label_normal").html(objOption.product_option_type_label+':');
        objHtmlOption.find("input").val(objOption.product_option_type_value);
        objHtmlOption.find("input").val(objOption.product_option_type_value);
        objHtmlOption.find("input").attr('name', 'prod_option__'+objOption.product_option_type_handle);
        $(".js_prod_options_table").append(objHtmlOption.fadeIn());
    });

}

function adm_portal_listing_edit_init()
{
    $("#listing_zip").change(function(){

        var strNewZip = $(this).val();
        var strOldLinkPart = $("#listing_link_part").val();

        if(strNewZip != '')
        {
            var srtNewLinkPart = strNewZip+strOldLinkPart.substr(strOldLinkPart.indexOf("/"))
            $("#listing_link_part").val(srtNewLinkPart);
        }
    });
}


//recurring orders
function update_next_order_time(strFreq) {
    var month = 0;
    var days = 0;

    if (strFreq == 'week')
        days = 7;
    else if (strFreq == 'week2')
        days = 14;
    else if (strFreq == 'month')
        month = 1;
    else if (strFreq == 'month2')
        month = 2;
    else if (strFreq == 'month6')
        month = 6;
    else if (strFreq == 'year')
        month = 12;

    strCurrMonth = parseFloat(strLastOrderedTime.substr(4, 2));
    strCurrMonth -= 1;

    objDate = new Date(strLastOrderedTime.substr(0, 4), strCurrMonth, strLastOrderedTime.substr(6, 2));

    objNewDate = new Date(objDate.getFullYear(), objDate.getMonth() + month, objDate.getDate() + days);

    strNewYear = objNewDate.getFullYear();

    strNewMonth = objNewDate.getMonth();
    strNewMonth += 1;

    if (strNewMonth < 10)
        strNewMonth = '0' + strNewMonth;

    strNewDate = objNewDate.getDate();
    if (strNewDate < 10)
        strNewDate = '0' + strNewDate;

    strNewOrderTime = strNewYear + '' + strNewMonth + strNewDate + '000000';

    strNewOrderTimeFormatted = strNewMonth + '-' + strNewDate + '-' + strNewYear;

//    document.getElementById('recurring_order_cart_next_order_time').value = '20071012';
    document.getElementById('recurring_order_cart_next_order_time').value = strNewOrderTime;
    document.getElementById('recurring_order_cart_next_order_time_date').value = strNewOrderTimeFormatted;
}

function recurring_order_init(strType)
{
    if(strType == 'edit')
        recurring_order_edit();

    recurring_order_check_fequency();
    recurring_order_recalculate_price();

    $("#recurring_order_cart_quantity, #recurring_order_cart_price, #recurring_order_cart_quantity_next, #recurring_order_cart_price_next, #recurring_order_cart_override").bind("change keyup",function(){
        recurring_order_recalculate_price();
    });


}

function recurring_order_check_fequency() {
    $("#recurring_order_cart_frequency").change(function () {
        var strFreq = $(this).val();
        if (typeof strLastOrderedTime !== 'undefined') {
            update_next_order_time(strFreq);
        }
    });
}

function recurring_order_edit() {
    var strInitStatus = $("#recurring_order_cart_status").val();

    if (strInitStatus == '4')
        $("#recurring_order_cart_status option[value='0']").attr('disabled', 'disabled').hide();
    else if (strInitStatus == '0')
        $("#recurring_order_cart_status option[value='4']").attr('disabled', 'disabled').hide();
    else
        $("#recurring_order_cart_status option[value='4'], #recurring_order_cart_status option[value='0']").attr('disabled', 'disabled').hide();
}

function recurring_order_recalculate_price() {

    if ($("#recurring_order_cart_override").is(":checked")) {
        $(".js_price_override").show();
    } else {
        $(".js_price_override").hide();
    }
    var intQty = $("#recurring_order_cart_quantity").val() * 1;
    var intPrice = $("#recurring_order_cart_price").val().replace(/[^0-9\.]+/g, '') * 1;
    var intTotal = 0;
    var strTotal = '';

    var intNextQty = $("#recurring_order_cart_quantity_next").val() * 1;
    var intNextPrice = $("#recurring_order_cart_price_next").val().replace(/[^0-9\.]+/g, '') * 1;
    var intNextTotal = 0;
    var strNextTotal = '';

    //default total
    if (intQty >= 0 && intPrice >= 0)
        intTotal = intPrice * intQty;

    if (intTotal >= 0)
        strTotal = '$' + Math.round(intTotal * 100) / 100;
    else
        strTotal = '';

    $(".js_re_total").html(strTotal);


    //next total
    if (intNextQty >= 0 && intNextPrice >= 0)
        intNextTotal = intNextQty * intNextPrice;

    if (intNextTotal >= 0)
        strNextTotal = '$' + intNextTotal;
    else
        strNextTotal = '';

    $(".js_re_total_next").html(strNextTotal);
}



//Toggle notes/tasks
function task_note_toggle_all(boolShow)
{
    var strTextMore  = 'More';
    var strTextLess  = 'Less';

    if (boolShow) {
        $(".js_task_info_more").show();
        $(".js_task_info_1").addClass("open");
        var boolNext = 0;
        var strImage = 'pluroweb-collapse-up';
        strText = strTextLess;
    } else {
        $(".js_task_info_more").hide();
        $(".js_task_info_1").removeClass("open");
        var boolNext = 1;
        var strImage = 'pluroweb-expand-down';
        strText = strTextMore;
    }

    $(".task_note_toggle_all_text").html(
        '<a href="javascript:task_note_toggle_all('+boolNext+');">'
        + strText + '</a>');

    $(".task_note_toggle_all_image").html(
        '<a href="javascript:task_note_toggle_all('+boolNext+');"><img src="core/assets/images/adm/'+strImage+'.gif"  border="0" height="16" width=""></a>');
}

$(document).ready(function() {
    $("a[href^='mailto:']").click(function(e) {
        e.preventDefault();
        boolPreload = false;
        window.top.boolPreload = false;
        window.boolPreload = false;
        window.top.location = $(this).attr("href");
        return false;
    });

    $(".js_task_info_1 .more_bt").click(function(e){
        e.preventDefault();
        $(this).parent().parent().toggleClass('open');
        $(this).parent().parent().find(".js_task_info_more").toggle(100);
    });
    load_search_sidebar_status();
    calculate_time_length_field();
    calculate_task_length_field();
    //go to the last tab when click generate report

    $(".generate_report").click(function (e){
        //e.preventDefault();
        $(".tab_normal:contains('X')").click();
        //$(this).parents().find('form').submit();

    });
});


function update_directory_listing_content_body(objSelect)
{
    if (typeof CKEDITOR.instances['directory_listing_content_body'] != "undefined") {
        if (objSelect.value == '') {
            CKEDITOR.instances['directory_listing_content_body'].setData('')
        } else {
            if (typeof objDirectoryListingContent != "undefined") {
                for (var intI = 0; intI <= objDirectoryListingContent.length; intI++) {
                    if (objSelect.value == objDirectoryListingContent[intI].directory_listing_content_handle) {
                        CKEDITOR.instances['directory_listing_content_body'].setData(
                            objDirectoryListingContent[intI].directory_listing_content_body
                        );
                        return;
                    }
                }
            }
        }
    }
}

(function() {
    'use strict';

    /**
     * Extracts degree acronyms from a degree selector
     *
     * @param {HTMLSelectElement|null} select
     * @return {string[]}
     */
    const getDegreeAcronyms = function(select) {
        const acronyms = [];

        if (select && select.selectedOptions) {
            // we expect option text in the form of "acronym (description)"
            Array.from(select.selectedOptions).forEach(function(option) {
                acronyms.push(option.textContent.split(' (')[0]);
            });
        }

        return acronyms;
    };

    (function() {
        const normalizeDegree = function(degree) {
            if (!degree) {
                return '';
            }

            degree = degree.replace(/[^a-z0-9\-]*/gi, '').toLowerCase();

            return degree ? '-' + degree : '';
        };

        const clear_portal_link_part = function(strIn) {
            let strOut = strIn.toLowerCase();
            strOut = strOut.replace(/[\s,.]/g, '-');
            strOut = strOut.replace(/[&]/g, '-and-');

            strOut = strOut.replace(/[^a-z0-9\-]*/gi, '');
            strOut = strOut.replace(/-+/g,'-');

            if (strOut.slice(-1) === '-') {
                strOut = strOut.slice(0, -1);
            }

            return strOut;
        };

        const set_portal_link_part = function(strListingPrimary) {
            if (strListingPrimary === '1') {
                $("#listing_link_part").val(
                    clear_portal_link_part($("#listing_zip").val()) + '/' +
                    clear_portal_link_part($("#listing_company").val())
                );
                return;
            }

            $("#listing_link_part").val(
                clear_portal_link_part($("#listing_zip").val()) + '/' +
                clear_portal_link_part($("#listing_fname").val()) + '-' +
                clear_portal_link_part($("#listing_lname").val()) +
                normalizeDegree(getDegreeAcronyms(document.getElementById('degreesPrimary'))[0])
            );
        };

        window.generate_listing_link_part = function(strListingPrimary, strListingType) {
            if (typeof(strListingType) !== "undefined" && strListingType === "website") {
                return;
            }

            $(document).ready(function() {
                if (!($("#listing_link_part").val())) {
                    set_portal_link_part(strListingPrimary);
                }

                if (strListingPrimary === '1') {
                    $("#listing_company, #listing_zip").bind('change', function() {
                        set_portal_link_part(strListingPrimary);
                    });
                    return;
                }

                $("#listing_fname, #listing_lname, #degreesPrimary, #degreesSecondary, #listing_zip").bind('change', function() {
                    set_portal_link_part(strListingPrimary);
                });
            });
        };
    })();

    (function() {
        const getDegrees = function() {
            const primary = document.getElementById('degreesPrimary');
            const secondary = document.getElementById('degreesSecondary');

            const degrees = getDegreeAcronyms(primary).concat(getDegreeAcronyms(secondary));

            return degrees.join(',');
        };

        const set_portal_listing_name = function(strListingPrimary) {
            const companyName = $("#listing_company").val();
            if (strListingPrimary === '1') {
                if (companyName) {
                    $("#listing_name").val(companyName);
                }
                return;
            }

            let strName = '';
            if (companyName) {
                strName = companyName;
            }

            if ($("#listing_fname").val()) {
                if (strName) {
                    strName += ' - ';
                }
                strName += $("#listing_fname").val();
            }

            if ($("#listing_lname").val()) {
                if (strName) {
                    strName += ', ';
                }
                strName += $("#listing_lname").val();
            }

            const degrees = getDegrees();
            if (degrees) {
                if (strName) {
                    strName += ' ';
                }
                strName += degrees;
            }

            if (strName) {
                $("#listing_name").val(strName);
            }
        };

        window.generate_listing_name = function(strListingPrimary) {
            $(document).ready(function() {
                if (!($("#listing_name").val())) {
                    set_portal_listing_name(strListingPrimary);
                }

                if (strListingPrimary === '1') {
                    $("#listing_company").bind('change', function() {
                        set_portal_listing_name(strListingPrimary);
                    });
                    return;
                }

                $("#listing_fname, #listing_lname, #degreesPrimary, #degreesSecondary, #listing_company").bind('change', function() {
                    set_portal_listing_name(strListingPrimary);
                });
            });
        };
    })();
})();

function onchange_dba_task_list_filter_type(objTaskType, strStatusElementId, strStatusValueAll)
{
    var objStatusElement = document.getElementById(strStatusElementId);
    if (objStatusElement != null) {
        objStatusElement.value = strStatusValueAll;
    }

    /*
    if (objTaskType.value == '__all' || objTaskType.value == '') {

    } else if (objTaskType.value == '__all_notes') {

    } else {

    }
    */
}

function onchange_crm_tasks_filter_dba_list_filter_status(strTimeIdentifier)
{
    if (strTimeIdentifier == '__all_due_today') {
        var objCurrentDate = new Date();
        var strCurrentYear = objCurrentDate.getFullYear();
        var strCurrentMonth = objCurrentDate.getMonth();
        strCurrentMonth += 1;
        if(strCurrentMonth < 10) {
            strCurrentMonth = '0' + strCurrentMonth;
        }
        var strCurrentDay = objCurrentDate.getDate();
        if(strCurrentDay < 10) {
            strCurrentDay = '0' + strCurrentDay;
        }

        var strFromTime = strCurrentYear + '' + strCurrentMonth + strCurrentDay + '000000';
        var strFromTimeFormatted = strCurrentMonth+'-'+strCurrentDay+'-'+strCurrentYear;
        document.getElementById('dba_list_filter_due_time_from').value = strFromTime;
        document.getElementById('dba_list_filter_due_time_from_date').value = strFromTimeFormatted;

        var strDueTime = strCurrentYear + '' + strCurrentMonth + strCurrentDay + '235959';
        var strDueTimeFormatted = strCurrentMonth+'-'+strCurrentDay+'-'+strCurrentYear;
        document.getElementById('dba_list_filter_due_time_to').value = strDueTime;
        document.getElementById('dba_list_filter_due_time_to_date').value = strDueTimeFormatted;
    } else if (strTimeIdentifier == '__all_due_this_week') {
        var objCurrentDate = new Date();
        var objFirstDate = new Date(objCurrentDate.setDate(objCurrentDate.getDate() - (objCurrentDate.getDay() - 1)));
        var objLastDate = new Date(objCurrentDate.setDate(objCurrentDate.getDate() - objCurrentDate.getDay()+7));

        var strFirstYear = objFirstDate.getFullYear();
        var strFirstMonth = objFirstDate.getMonth();
        strFirstMonth += 1;
        if(strFirstMonth < 10) {
            strFirstMonth = '0' + strFirstMonth;
        }
        var strFirstDay = objFirstDate.getDate();
        if(strFirstDay < 10) {
            strFirstDay = '0' + strFirstDay;
        }
        var strFromTime = strFirstYear + '' + strFirstMonth + strFirstDay + '000000';
        var strFromTimeFormatted = strFirstMonth+'-'+strFirstDay+'-'+strFirstYear;
        document.getElementById('dba_list_filter_due_time_from').value = strFromTime;
        document.getElementById('dba_list_filter_due_time_from_date').value = strFromTimeFormatted;

        var strLastYear = objLastDate.getFullYear();
        var strLastMonth = objLastDate.getMonth();
        strLastMonth += 1;
        if(strLastMonth < 10) {
            strLastMonth = '0' + strLastMonth;
        }
        var strLastDay = objLastDate.getDate();
        if(strLastDay < 10) {
            strLastDay = '0' + strLastDay;
        }
        var strToTime = strLastYear + '' + strLastMonth + strLastDay + '235959';
        var strToTimeFormatted = strLastMonth+'-'+strLastDay+'-'+strLastYear;
        document.getElementById('dba_list_filter_due_time_to').value = strToTime;
        document.getElementById('dba_list_filter_due_time_to_date').value = strToTimeFormatted;
    }
}

/**
 * Toggles visibility of next neighbor element to event firer
 *
 * @param  {Event} e
 * @return {void}
 */
function toggle_next_sibling(e) {
    e.preventDefault();

    var elTarget = e.target.nextSibling;

    if (!elTarget) {
        return;
    }

    while (elTarget.nodeType !== 1 && elTarget.nextSibling) {
        elTarget = elTarget.nextSibling;
    }

    if (elTarget.nodeType !== 1) {
        return;
    }

    toggle_element(elTarget);
}

/**
 * Toggles visibility of previous neighbor element to event firer
 *
 * @param  {Event} e
 * @return {void}
 */
function toggle_prev_sibling(e) {
    e.preventDefault();

    var elTarget = e.target.previousSibling;

    if (!elTarget) {
        return;
    }

    while (elTarget.nodeType !== 1 && elTarget.previousSibling) {
        elTarget = elTarget.previousSibling;
    }

    if (elTarget.nodeType !== 1) {
        return;
    }

    toggle_element(elTarget);
}

/**
 * Toggles visibility of element matching selector in event firer's data
 *
 * @param  {Event} e
 * @return {void}
 */
function toggle_target(e) {
    e.preventDefault();

    var arrSel = e.target.getAttribute('data-target').split(',');
    arrSel.forEach(function(strSel) {
        var elTarget = document.querySelector(strSel);
        if (!elTarget) {
            return;
        }

        toggle_element(elTarget);
    });
}

/**
 * Shared functionality for toggling visibility of an element
 *
 * @param  {ElementNode} elTarget Element to toggle
 * @return {void}
 */
function toggle_element(elTarget) {
    var strNewStyle = '';

    if (elTarget.style.display == '') {
        strNewStyle = 'none';
    }
    elTarget.style.display = strNewStyle;
}


/**
 * Copies a password to the clipboard
 *
 * @param  {Event} e Click event that initiated copy
 * @return {void}
 */
function copy_password(e) {
    e.preventDefault();
    var elTop = e.target.parentNode.parentNode;

    var elTarget = elTop.querySelector('[data-password]');
    if (!elTarget) {
        elTarget = elTop.querySelector('.js-password');
    }
    if (!elTarget) {
        elTarget = elTop.querySelector('#password_text');
    }
    if (!elTarget) {
        return;
    }
    if (elTarget.value === '************') {
        elTarget = elTop.querySelector('#hidden_password_text');
    }
    if (!elTarget) {
        return;
    }

    var elCurrent = document.activeElement;

    var elTemp = document.createElement('textarea');
    document.body.appendChild(elTemp);
    elTemp.style.position = 'absolute';
    elTemp.style.left = '-99999px';
    elTemp.style.top = '0';

    var strValue = elTarget.value;
    if (!strValue) {
        strValue = elTarget.textContent;
    }
    elTemp.textContent = strValue.replace(/\s/g , '');
    elTemp.focus();
    elTemp.setSelectionRange(0, elTemp.value.length);
    document.execCommand('copy');

    elCurrent.focus();
    document.body.removeChild(elTemp);
}

/**
 * Copies a username to the clipboard
 *
 * @param  {Event} e Click event that initiated copy
 * @return {void}
 */
function copy_username(e) {
    e.preventDefault();
    var elTop = e.target.parentNode.parentNode;

    var elTarget = elTop.querySelector('#username_text');

    var elCurrent = document.activeElement;

    var elTemp = document.createElement('textarea');
    document.body.appendChild(elTemp);
    elTemp.style.position = 'absolute';
    elTemp.style.left = '-99999px';
    elTemp.style.top = '0';

    var strValue = elTarget.value;
    if (!strValue) {
        strValue = elTarget.textContent;
    }
    elTemp.textContent = strValue.replace(/\s/g , '');
    elTemp.focus();
    elTemp.setSelectionRange(0, elTemp.value.length);
    document.execCommand('copy');

    elCurrent.focus();
    document.body.removeChild(elTemp);
}

/**
 * Refresh user info on user edit page
 */
function userEditRefresh()
{
    if (typeof strUserId === 'undefined') {
        return;
    }
    var strLoginSelector = '#form_users_edit';

    $(strLoginSelector).unbind('after_load').bind('after_load', function(){
        var objData = objAjaxResults = $(strLoginSelector).data('json');
        if (!objData) {
            return false;
        }

        $.each(objData, function (k, v){
            $('.js_' + k).html(v);
        });
    });

    $.AjaxInit({
        'strContentSelector': strLoginSelector,
        'strUrl': '?ph=ajax',
        'strData': '',
        'strExtraData': 'ajax_handle=user_edit_refresh&record_id='+strUserId,
        'json': true
    });
}

/**
 * Multi-submit protection for forms
 * Ugly as hell but we scatter inputs all over soooo
 *
 * @return {void}
 */
(function() {
    window.addEventListener('load', function() {
        var listForms = document.querySelectorAll('form');
        if (!listForms || 'object' !== typeof FormValidator) {
            return;
        }

        var funcSubmit = function(event) {
            var listInputs = document.querySelectorAll('input');
            if (!listInputs) {
                return;
            }

            [].forEach.call(listInputs, function(elInput) {
                elInput.classList.add('disabled_link');
            });

            document.body.addEventListener('keydown', function(event) {
                if (event.keyCode.toString() === '13') {
                    event.preventDefault();
                }
            });
        };

        if ('undefined' !== typeof FormValidator) {
            [].forEach.call(listForms, function(elForm) {
                elForm.addEventListener('submit', funcSubmit);
                FormValidator.setTabHelper(elForm);
            });
        }
    });
})();

/**
 * product_custom_recurring_frequency field change handler
 * @param value
 */
function productEditCustomRecurringFreqChange(value)
{
    $('.product_custom_recurring_frequency_toggle').hide();
    $('.product_custom_recurring_frequency_' + value).show();
}
